import {Button, Stack} from '@mui/material';
import React from 'react';

import {EmptySearchState} from 'presentation/components';

import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {LocalitiesNotFoundStateProps} from './types';
import {Loading} from 'presentation/components/Loading/Loading';

const {noResults, callToChat, emptyDescription} = translations['pt-br'].commons;

export function LocalitiesNotFoundState({flowType}: LocalitiesNotFoundStateProps) {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const handleCallChatRoom = async () => {
		await callChatRoom(flowType === FlowEnum.EXAM ? ChatRoomsEnum.EXAMS : ChatRoomsEnum.APP);
	};

	return (
		<EmptySearchState
			dataTagId={FinishWithoutCompleteFlowEnum.SEM_LOCALIDADE_DISPONIVEL}
			title={noResults}
			description={emptyDescription}>
			<Stack gap={2}>
				<Button
					variant={'contained'}
					size="large"
					data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
					onClick={handleCallChatRoom}
					disabled={callChatRoomIsLoading}
					endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
					{callToChat}
				</Button>
			</Stack>
		</EmptySearchState>
	);
}
